"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var pageRefreshWithTime = function pageRefreshWithTime(_ref) {
  var _global$__appConfig__;
  var router = _ref.router;
  if (!((_global$__appConfig__ = global.__appConfig__) !== null && _global$__appConfig__ !== void 0 && _global$__appConfig__.timeAfterRefreshPage)) {
    return;
  }
  if (!document.body.dataset.firstTimeRegistered) {
    document.body.dataset.firstTimeRegistered = Date.now();
    document.addEventListener("click", function () {
      var timeToRefreshPage = Date.now() - document.body.dataset.firstTimeRegistered > global.__appConfig__.timeAfterRefreshPage;
      if (timeToRefreshPage) {
        router.reload();
      }
    });
  }
};
var _default = pageRefreshWithTime;
exports["default"] = _default;